export const GROUP_CUSTOM_ID = {
    BUSINESS: 'BUSINESS',
    EDUCATION: 'EDUCATION',
}
